// extracted by mini-css-extract-plugin
export var footer = "_o4-5";
export var fulfillmentInput = "_o4-0";
export var shipDateInput = "_o4-1";
export var shipmentModal = "_o4-2";
export var shipmentModalContent = "_o4-3";
export var tableContainer = "_o4-4";